import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const Logo = ({ image }) => {
    if (!image) return null;

    const src = image.startsWith('http') || image.startsWith(process.env.PUBLIC_URL)
        ? image
        : `${process.env.PUBLIC_URL}${image}`;

    return (
        <div className="logo">
            <Link to={process.env.PUBLIC_URL + "/"}>
                <img src={src} alt="Corporate Logo" style={{ display: 'block' }} />
            </Link>
        </div>
    );
};

Logo.propTypes = {
    image: PropTypes.string,
};

export default Logo;
